"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactEvents = void 0;
var ContactEvents;
(function (ContactEvents) {
    ContactEvents["EmployeeCreated"] = "contact.employee.Created";
    ContactEvents["PersonCreated"] = "contact.person.Created";
    ContactEvents["CompanyCreated"] = "contact.company.Created";
})(ContactEvents || (exports.ContactEvents = ContactEvents = {}));
//# sourceMappingURL=analytics.js.map